import request from '../utils/http'
// 列表
export function list (query) {
  return request({
    url: '/coupon/api/subscription',
    headers: {
      'Custom-Params': 'javaApi'
    },
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/ComboOrder.js